import React from 'react';
import { Grid } from '@material-ui/core';
import { useTranslation, Trans } from 'react-i18next';
import { ShopButton } from 'components';
import img from 'images';
import { getAppFlavor, isFitanu } from 'config/theme';
import { LanguageType } from 'types';
import config from 'config';
import {
  Wrapper,
  Title,
  Subtitle,
  ButtonsWrapper,
  LeftContainer,
  RightContainer,
  Image,
  Link,
} from './BottomSection.style';
import { PRIVACY_POLICY, TERMS, STORE } from './BottomSection.utils';

const BottomSection = () => {
  const { t } = useTranslation();
  const appFlavor = getAppFlavor();
  const appLanguage = config.LANGUAGE as LanguageType;

  return (
    <Wrapper container id="app-description">
      <LeftContainer container item xs={12} sm={12} md={6}>
        <Title>
          {t('bottomSection.download_1')}&nbsp;{t('bottomSection.download_2')}
        </Title>
        <Grid item xs={12} container direction="column" alignItems="stretch">
          <Subtitle>{t(`${appFlavor}_AFTER_DOWNLOADING`)}</Subtitle>
          <Subtitle>{t(`${appFlavor}_EVERY_MONTH`)}</Subtitle>
          <Subtitle>
            <Trans i18nKey={`${appFlavor}_DONT_WAIT`} t={t} />
          </Subtitle>
          <Subtitle>
            {t('bottomSection.termsOfService')}&nbsp;
            <Link href={TERMS[appLanguage][appFlavor]} target="_blank">
              {isFitanu() ? 'FITANU.COM' : 'Martes Sport'}
            </Link>
          </Subtitle>
          <Subtitle>
            {t('bottomSection.privacyPolicy_1')}&nbsp;
            <Link href={PRIVACY_POLICY[appLanguage][appFlavor]} target="_blank">
              {t('bottomSection.privacyPolicy_2')}
            </Link>
          </Subtitle>
        </Grid>
        <ButtonsWrapper>
          <ShopButton shop="apple" />
          <ShopButton shop="google" />
        </ButtonsWrapper>
      </LeftContainer>
      <RightContainer item container xs={12} sm={12} md={6}>
        <Image
          src={img[appLanguage].phoneCropped[appFlavor]}
          alt="Phone with martes mobile app"
        />
      </RightContainer>
    </Wrapper>
  );
};

export default BottomSection;
